import { api } from './api';
import { mapUserProfileFromResponse } from 'utils/userProfileResponse';

// Maps splitshire-v2 login response to admin app shape
// v2 returns: { message, data: { user, token }, success }
const mapLoginResponse = (response) => {
  if (!response?.data) return response;
  return {
    ...response,
    access_token: response.data.token,
    user: response.data.user,
  };
};

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // splitshire-v2: POST /auth/login { email, password } -> { data: { user, token }, success }
    login: builder.mutation({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: mapLoginResponse,
      invalidatesTags: ['Auth'],
    }),
    // Admin login uses same v2 auth/login API
    adminLogin: builder.mutation({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: mapLoginResponse,
      invalidatesTags: ['Auth'],
    }),
    register: builder.mutation({
      query: (data) => ({
        url: '/auth/register',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Auth'],
    }),
    // splitshire-v2: POST forgot-password { email }
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: '/forgot-password',
        method: 'POST',
        body: data,
      }),
    }),
    // splitshire-v2: PUT reset-password?email=&token= with body { password, confirmPassword }
    resetPassword: builder.mutation({
      query: ({ email, token, ...body }) => ({
        url: `/reset-password?email=${encodeURIComponent(email || '')}&token=${encodeURIComponent(token || '')}`,
        method: 'PUT',
        body,
      }),
    }),
    getProfile: builder.query({
      query: () => '/auth/me',
      transformResponse: mapUserProfileFromResponse,
      providesTags: ['Auth'],
    }),
    updateProfile: builder.mutation({
      query: (data) => ({
        url: '/profile',
        method: 'PATCH',
        body: data,
      }),
      transformResponse: mapUserProfileFromResponse,
      invalidatesTags: ['Auth'],
    }),
    uploadAvatar: builder.mutation({
      query: (file) => {
        const formData = new FormData();
        formData.append('avatar', file);
        return {
          url: '/profile/avatar',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Auth'],
    }),
    changePassword: builder.mutation({
      query: (data) => ({
        url: '/profile/change-password',
        method: 'POST',
        body: data,
      }),
    }),
    checkUsername: builder.query({
      query: (username) => `/auth/check-username?username=${encodeURIComponent(username)}`,
    }),
  }),
});

export const {
  useLoginMutation,
  useAdminLoginMutation,
  useRegisterMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useGetProfileQuery,
  useUpdateProfileMutation,
  useUploadAvatarMutation,
  useChangePasswordMutation,
  useCheckUsernameQuery,
} = authApi;

